import fkOrId from '@drivesally/sally-fw/lib/lib/fkOrId';

const isShortcutAvailable = (shortcut, {userId, userTeamIds = []} = {}) => {
  const shortcutUserId = fkOrId(shortcut?.user);
  const shortcutTeamId = fkOrId(shortcut?.team);

  if (shortcutUserId) return !!userId && shortcutUserId === userId;
  if (shortcutTeamId) return userTeamIds.includes(shortcutTeamId);
  return true;
};

export default isShortcutAvailable;
